import * as React from 'react'
import { connect } from 'react-redux'
import type { State } from 'types/redux'
import { getIsTrial } from '@disco/state-management/selectors/business'
import Alert from 'components/ui/alert'
import Button from 'components/ui/button'
import ContactUsLink from 'components/ui/contact-us-link'
import Video from 'components/ui/video'
import styles from './index.module.css'

function mapStateToProps(state: State): any {
  const isTrial = getIsTrial(state)
  return {
    isTrial,
  }
}

type Props = {
  isTrial?: boolean
  getStarted?: () => unknown
}

const CampaignIntroduction = ({ isTrial, getStarted }: Props) => {
  const btn = isTrial ? (
    <Button
      appearance="primary"
      link="/settings/billing"
      caption="Subscribe to access"
    />
  ) : (
    <ContactUsLink
      type="button"
      intercomMsg="I'm interested in upgrading my account to access the Email Creator"
    >
      Upgrade to access
    </ContactUsLink>
  )
  const video = {
    wistia: 'https://disco.wistia.com/embed/iframe/0j2crjcstv',
  }
  return (
    <div className={styles.campaignIntroductionWrapper}>
      <div className={styles.campaignIntroductionGraphics}>
        <Video src={video.wistia} width={510} height={290} />
      </div>
      <div className={styles.campaignIntroductionText}>
        <div className={styles.campaignIntroductionHeader}>
          Introducing the Email Creator
        </div>
        <div className={styles.campaignIntroductionBody}>
          Create beautiful email campaigns in a flash with our simple drag and
          drop Email Creator. Gain deeper insights beyond opens and clicks and
          discover who streamed and downloaded individual tracks with our
          comprehensive analytics.
        </div>
        {getStarted ? (
          <Button
            appearance="primary"
            onClick={getStarted}
            caption="Get started"
          />
        ) : (
          <Alert actions={btn}>
            The Email Creator is available on Plus. Pro and Enterprise plans.
          </Alert>
        )}
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(CampaignIntroduction) as any
